var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPresent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#171717",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0532 25.5819C16.0506 25.5819 16.0476 25.5819 16.0451 25.5819C15.939 25.5797 15.839 25.5344 15.7672 25.4566L8.43661 17.4856C8.31091 17.3488 8.29937 17.1427 8.40925 16.9926C8.51912 16.843 8.71921 16.7917 8.88766 16.8704L15.597 20.0119C15.6535 20.0384 15.7201 20.0256 15.7633 19.9807L25.9977 9.28411C26.1363 9.13918 26.3629 9.12336 26.5202 9.2482C26.6775 9.37304 26.7139 9.59707 26.604 9.76509L16.4234 25.3608C16.4089 25.3835 16.3918 25.404 16.373 25.4233L16.3281 25.4681C16.255 25.5408 16.1558 25.5819 16.0532 25.5819Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresent);
export default __webpack_public_path__ + "static/media/present.c6140f24ad31ebbec0c354e7c6b637bb.svg";
export { ForwardRef as ReactComponent };